import apiVoucher from '@/api/voucher';
import apiOption from '@/api/option';
import moment from 'moment';

const defaultState = () => ({
    voucherResults: [],
	voucherPagination: '',
    voucher: {
        claimed: 0,
        unclaimed: 0,
    },
	voucherData: {},
    checkVoucher: false,
    loading: false,
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {};

const mutations = {
    listVoucher(state, data) {
		state.voucherResults = data.data
		state.voucherPagination = data.pagination;
        state.voucher.claimed = data.total.claimed
        state.voucher.unclaimed = data.total.unclaimed
	},
    setVoucher(state, data) {
		state.voucherData = data.data
	},
    setCheckVoucher(state, data) {
        state.checkVoucher = data
    },
    setLoading(state, data){
        state.loading = data
    },
    setOptionWarehouse(state,data){
        state.optionWarehouse = []
        state.optionWarehouse = data
    },
    saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alert = ''
	},
    failed(state, data) {
		state.alert = data
	},
    clearDataVoucher(state) {
		Object.assign(state, defaultState());
	}
}

const actions = {
    async getListVoucher({ commit }, params) {
        await apiVoucher.getListVoucher(params).then(({ data: { data } }) => {
            commit('listVoucher', { data: data.results, pagination: data.pagination, total: data.total});
        }).catch(() => {
            commit('listVoucher', { data: [], pagination: {}, total: {} });
        });
    },
    async getVoucher({ commit, dispatch }, params) {
        await apiVoucher.getDataVoucher(params).then(({ data }) => {
            if(data.code == 200){
                let dateNow = new Date().getTime();
                let expiredDate = new Date(data.data.voucher_expired_datetime).getTime();
                let expiredDateFormatted = moment(data.data.voucher_expired_datetime).format('dddd, DD MMMM YYYY');

                if(dateNow > expiredDate){
                    dispatch('errorHandler', { message: `Voucher sudah expired sejak ${expiredDateFormatted}` })
                    commit('setVoucher', { data: {} });
                    commit('setCheckVoucher', false);
                } else {
                    dispatch('success', "Voucher tersedia dan dapat digunakan")
                    commit('saveResponse', data);
                    commit('setCheckVoucher', true);
                    commit('setVoucher', { data: data.data });
                }
            }
        }).catch((err) => {
            commit('setVoucher', { data: {} });
            commit('setCheckVoucher', false);
            const data = err.response.data
            dispatch("errorHandler", data)
        });
    },
    async exportVoucher({ commit, dispatch }, params){
        await dispatch('isAttempting', null, { root: true })
        await apiVoucher.exportVoucher(params).then(({ data: { data } }) => {
            dispatch('success', data.results.message)
            window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
        }).catch(() => {
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal memproses export data voucher'
            }, { root: true });
        });
        await dispatch('attempted', null, { root: true })
    },
    async claimVoucher({ dispatch, commit }, value) {
        await dispatch('isAttempting', null, { root: true })
        await apiVoucher.processClaimVoucher(value).then( res => {
            dispatch('success', "Voucher berhasil diklaim")
            commit("saveConfirmResponse", res);
            commit('setCheckVoucher', false);
        })
        .catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
            commit('setCheckVoucher', false);
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal klaim voucher'
            }, { root: true });
        });
        await dispatch('attempted', null, { root: true })
    },
    getOptionWarehouse({ dispatch }, params) {
        return new Promise((resolve, reject) => {
            apiOption.getOptionWarehouseAll(params).then(({ data: { data } }) => {
                let warehouse = data.results.map((value) => {
                    value.warehouse_id = value.warehouse_name
                    return value
                })
                resolve(warehouse)
            }).catch( err => {
                reject([])
                const data = err.response.data
                dispatch("errorHandler", data, { root: true })
            });
        })
    },
    success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data
		}, { root: true });
	},
    errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};